import React, { FC, useState, useRef, useEffect } from "react";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import MapboxGL from "components/MapboxGL/MapboxGL";
import { JourneeType, EventType } from "data/types";
import CardLieuIntegre from "components/CardLieuIntegre/CardLieuIntegre";
import CardTrajetIntegre from "components/CardTrajetIntegre/CardTrajetIntegre";
import CardNuitIntegre from "components/CardNuitIntegre/CardNuitIntegre";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from "react-dnd-html5-backend";
import { useTranslation } from 'react-i18next';
import { Tooltip } from "react-tooltip";
import 'react-tooltip/dist/react-tooltip.css';

export interface SectionCarteIntegreProps {
  voyageKey: string;
  emailPartage: string;
  codePartage: string;
  eventCategoriesPage: JourneeType[]; 
  etatVoyage: number;
  id_pays: string;
  numDroit: number;   
  symbole_monnaie?: string;
  nb_voyageurs: number;
}

const SectionCarteIntegre: FC<SectionCarteIntegreProps> = ({
  voyageKey,
  emailPartage,
  codePartage,
  eventCategoriesPage,
  etatVoyage,
  id_pays,
  numDroit,
  symbole_monnaie,
  nb_voyageurs
}) => {
  
  const { t } = useTranslation();
  
  const [eventCategories, setEventCategories] = useState<JourneeType[]>([]);
  const [showFullMapFixed, setShowFullMapFixed] = useState(false);
  const [compteurClick, setCompteurClick] = useState<number>(0);
  const [selectedCardID, setSelectedCardID] = useState<string | null>(null);
  const [selectedMarkerID, setSelectedMarkerID] = useState<string | null>(null);
  const [placementCardID, setPlacementCardID] = useState<string | null>(null);
  const listContainerRef = useRef<HTMLDivElement>(null);
  const listContainerRefSmall = useRef<HTMLDivElement>(null);

  const [isEnoughPoints, setIsEnoughPoints] = useState(false);

  const getCardID = (event: EventType): string => {
    let cardID = "";
    if (event.typeEv === "L") {
      cardID = "lieu-" + event.id;
    } else if (event.typeEv === "T") {
      cardID = "trajet-" + event.id;
    } else if (event.typeEv === "N") {
      cardID = "nuit-" + event.id;
    }
    return cardID;
  };

  const cleanMarkerID = (markerID: string): string => {
    if (markerID.startsWith("arrivee-")) {
      return markerID.substring("arrivee-".length);
    } else if (markerID.startsWith("depart-")) {
      return markerID.substring("depart-".length);
    } else if (markerID.startsWith("ville-")) {
      return markerID.substring("ville-".length);
    } else if (markerID.startsWith("hebergement-")) {
      return markerID.substring("hebergement-".length);
    } else {
      return markerID;
    }
  };

  // Fonction pour gérer le clic sur un marqueur et mettre à jour l'ID de la carte sélectionnée
const handleMarkerClick = (markerID: string) => { 
  setSelectedMarkerID(null);
  

    const isScreenLessThanLG = window.matchMedia("(max-width: 992px)").matches;

    if (isScreenLessThanLG) {
      if (markerID && listContainerRefSmall.current) {
        markerID=cleanMarkerID(markerID);
        setSelectedMarkerID(markerID);
       
        const selectedCardElement = listContainerRefSmall.current.querySelector(`#${markerID}-small`);

      if (selectedCardElement  instanceof HTMLElement) {
      const scrollOffset = (listContainerRefSmall.current.offsetWidth - selectedCardElement.offsetWidth) / 2;
      listContainerRefSmall.current.scrollLeft = selectedCardElement.offsetLeft - scrollOffset;

        }
      }
    } else {
     if (markerID && listContainerRef.current) {
        markerID=cleanMarkerID(markerID);
        setSelectedMarkerID(markerID);
        const selectedCardElement = listContainerRef.current.querySelector(`#${markerID}`);

      if (selectedCardElement  instanceof HTMLElement) {
      selectedCardElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    }


};

  // Fonction pour mettre à jour l'ID de la carte sélectionnée
  const handleCardClick = (event: EventType, id: string, type?: String) => {
    
    setSelectedCardID(null);
    setSelectedMarkerID(null);
    
    if(((type === undefined || type === null || type === "depart" || type === "ville") && event.lat !== null && event.lat !== '' && event.longi !== null && event.longi !== '')
    || ((type === "arrivee" || type === "hebergement") && event.lat2 !== null && event.lat2 !== '' && event.longi2 !== null && event.longi2 !== ''))
    {
      const newCompteurClick=compteurClick+1; 
        
      if(type)
      {
        setSelectedCardID(type+"-"+id);  
        setCompteurClick(newCompteurClick);  
      }
      else{
        setSelectedCardID(id);        
        setCompteurClick(newCompteurClick);
      }     
    }
    else
    {
      
      alert("Pas de coordonnée GPS enregistrée donc non localisable.")
    }
  };

  const handleDeplacementMarker = async (lat1: any, longi1: any, lat2: any, longi2: any, typeEvenement: string, idEvenement: number, idJournee: number) => {

  }

  const handleEffacePlacement = () => {

  }

  const isEventVisible = (event: EventType) => {
  if (
    event.typeEv === "L" &&
    (
      (event.libelle1 !== null && event.libelle1 !== "") ||
      (event.libelle2 !== null && event.libelle2 !== "") ||
      (event.prix !== null && Number(event.prix.replace("", "0")) > 0)
    )
  ) {
    return true;
  }

  if (
    event.typeEv === "T" &&
    (
      (event.libelle1 !== null && event.libelle1 !== "") ||
      (event.libelle2 !== null && event.libelle2 !== "") ||
      (event.prix !== null && Number(event.prix.replace("", "0")) > 0) ||
      (event.type !== null && event.type !== "") ||
      (event.debut !== null && event.debut !== "") ||
      (event.fin !== null && event.fin !== "")
    )
  ) {
    return true;
  }

  if (
    event.typeEv === "N" &&
    event.invisible1 !== "O" &&
    (
      (event.libelle1 !== null && event.libelle1 !== "") ||
      (event.libelle2 !== null && event.libelle2 !== "") ||
      (event.prix !== null && Number(event.prix.replace("", "0")) > 0)
    )
  ) {
    return true;
  }

  return false;
};

const getTimelineIcon = (event: EventType) => {
  if (event.typeEv === "L") {
    return event.type && event.type !== "" ? "la-utensils" : "la-map-marker-alt";
  }

  if (event.typeEv === "T" && (!event.location || event.location !== "O")) {
    return event.type && event.type !== "" ? `la-${event.type}` : "la-route";
  }

  if (event.typeEv === "T" && event.location === "O") {
    return event.moment === "P" ? "la-key" : "la-undo-alt";
  }

  if (event.typeEv === "N") {
    return "la-bed";
  }

  return "la-circle";
};

const getTypetrajet = (event: EventType) => {
  if (event.typeEv === "L") {
    return event.type && event.type !== "" ? "repas" : "lieu";
  }

  if (event.typeEv === "T" && (!event.location || event.location !== "O")) {
    return "trajet";
  }

  if (event.typeEv === "T" && event.location === "O") {
    return event.moment === "P"
      ? "locationPriseEnCharge"
      : "locationRestitution";
  }

  if (event.typeEv === "N") {
    return "nuit";
  }

  return "";
};

const getTimelineColor = (event: EventType) => {
  if (event.typeEv === "L") {
    return event.type && event.type !== ""
      ? "bg-amber-50 text-amber-600 border-amber-100"
      : "bg-pink-50 text-pink-600 border-pink-100";
  }

  if (event.typeEv === "T") {
    return event.location === "O"
      ? "bg-purple-50 text-purple-600 border-purple-100"
      : "bg-green-50 text-green-600 border-green-100";
  }

  if (event.typeEv === "N") {
    return "bg-blue-50 text-blue-600 border-blue-100";
  }

  return "bg-neutral-50 text-neutral-500 border-neutral-100";
};

const getPreviousVisibleEvent = (dayIndex: number, eventIndex: number) => {
  const sameDayPrevious = eventCategoriesPage[dayIndex]?.evenements
    .slice(0, eventIndex)
    .reverse()
    .find((previousEvent) => isEventVisible(previousEvent));

  if (sameDayPrevious) {
    return {
      event: sameDayPrevious,
      dayIndex,
    };
  }

  for (let i = dayIndex - 1; i >= 0; i--) {
    const previousDayEvent = eventCategoriesPage[i]?.evenements
      .slice()
      .reverse()
      .find((previousEvent) => isEventVisible(previousEvent));

    if (previousDayEvent) {
      return {
        event: previousDayEvent,
        dayIndex: i,
      };
    }
  }

  return null;
};

const getNextVisibleEvent = (dayIndex: number, eventIndex: number) => {
  const sameDayNext = eventCategoriesPage[dayIndex]?.evenements
    .slice(eventIndex + 1)
    .find((nextEvent) => isEventVisible(nextEvent));

  if (sameDayNext) {
    return {
      event: sameDayNext,
      dayIndex,
    };
  }

  for (let i = dayIndex + 1; i < eventCategoriesPage.length; i++) {
    const nextDayEvent = eventCategoriesPage[i]?.evenements.find((nextEvent) =>
      isEventVisible(nextEvent)
    );

    if (nextDayEvent) {
      return {
        event: nextDayEvent,
        dayIndex: i,
      };
    }
  }

  return null;
};

const TimelineMobileIntegre = ({
  day,
  dayIndex,
  event,
  eventIndex,
  dayHeader,
  children,
}: {
  day: JourneeType;
  dayIndex: number;
  event: EventType;
  eventIndex: number;
  dayHeader: React.ReactNode;
  children: React.ReactNode;
}) => {
  const previousVisibleEvent = getPreviousVisibleEvent(dayIndex, eventIndex);
  const nextVisibleEvent = getNextVisibleEvent(dayIndex, eventIndex);

  const hasPrevious = previousVisibleEvent !== null;
  const hasNext = nextVisibleEvent !== null;

  const tooltipTypeId = `tooltip-type-integre-small-${event.typeEv}-${event.id}`;

  return (
    <div
      key={`${day.num_jour}-${eventIndex}-small-timeline`}
      id={`${getCardID(event)}-small`}
      className="
        relative

        flex-shrink-0
        flex-grow-0

        basis-[260px]
        w-[260px]
        min-w-[260px]
        max-w-[260px]

        overflow-visible
      "
    >
      {dayHeader}

      <div
        className="
          relative
          h-9
          mb-2
          overflow-visible
        "
      >
        {hasPrevious && (
          <div
            className="
              absolute
              top-1/2
              -left-3
              right-1/2

              h-[1px]
              -translate-y-1/2

              bg-neutral-300
              dark:bg-neutral-700
            "
          />
        )}

        {hasNext && (
          <div
            className="
              absolute
              top-1/2
              left-1/2
              -right-3

              h-[1px]
              -translate-y-1/2

              bg-neutral-300
              dark:bg-neutral-700
            "
          />
        )}

        <div
          className={`
            absolute
            left-1/2
            top-1/2
            z-10

            w-7
            h-7

            -translate-x-1/2
            -translate-y-1/2

            rounded-full
            border
            shadow-sm

            flex
            items-center
            justify-center

            ${getTimelineColor(event)}
          `}
        >
          <i
            className={`las ${getTimelineIcon(event)} text-sm`}
            data-tooltip-id={tooltipTypeId}
            data-tooltip-content={t(getTypetrajet(event))}
            data-tooltip-place="top"
          />

          <Tooltip id={tooltipTypeId} style={{ zIndex: 9999 }} />
        </div>
      </div>

      <div
        className="
          py-1
          text-center
          w-full
          max-w-full
          overflow-visible
        "
      >
        {children}
      </div>
    </div>
  );
};

const TimelineDesktopIntegre = ({
  dayIndex,
  event,
  eventIndex,
  children,
}: {
  dayIndex: number;
  event: EventType;
  eventIndex: number;
  children: React.ReactNode;
}) => {
  const previousVisibleEvent = getPreviousVisibleEvent(dayIndex, eventIndex);
  const nextVisibleEvent = getNextVisibleEvent(dayIndex, eventIndex);

  const nextVisibleEventIsInSameDay =
    nextVisibleEvent !== null && nextVisibleEvent.dayIndex === dayIndex;

  const shouldDrawLine = nextVisibleEvent !== null;

  const tooltipTypeId = `tooltip-type-integre-${event.typeEv}-${event.id}`;

  return (
    <div
      key={`${dayIndex}-${eventIndex}-timeline`}
      id={getCardID(event)}
      className="
        relative
        flex
        gap-2
        py-1
        text-center
        overflow-visible
      "
    >
      <div
        className="
          relative
          flex
          flex-col
          items-center
          w-7
          flex-shrink-0
        "
      >
        {previousVisibleEvent !== null && (
          <div
  className="
    absolute
    left-1/2
    top-[-37px]

    h-[38px]
    w-px
    -translate-x-1/2

    bg-neutral-400
    dark:bg-neutral-700
  "
/>
        )}

        {shouldDrawLine && (
         <div
  className={`
    absolute
    left-1/2
    top-[20px]

    w-px
    -translate-x-1/2

    ${
      nextVisibleEventIsInSameDay
        ? "-bottom-5"
        : "-bottom-[8px]"
    }

    bg-neutral-400
    dark:bg-neutral-700
  `}
/>
        )}

        <div
          className={`
            relative
            z-10

            w-6
            h-6

            rounded-full

            border
            shadow-sm

            flex
            items-center
            justify-center

            ${getTimelineColor(event)}
          `}
        >
          <i
            className={`las ${getTimelineIcon(event)} text-sm`}
            data-tooltip-id={tooltipTypeId}
            data-tooltip-content={t(getTypetrajet(event))}
            data-tooltip-place="top"
          />

          <Tooltip id={tooltipTypeId} style={{ zIndex: 9999 }} />
        </div>
      </div>

      <div className="min-w-0 flex-1">
        {children}
      </div>
    </div>
  );
};

  
  useEffect(() => {
    
    const nbPoints = eventCategoriesPage.reduce((count, jour) => {
      return count + jour.evenements.filter((evenement) => 
        (evenement.lat !== null && evenement.lat !== '' &&
        evenement.longi !== null && evenement.longi !== '') ||
        (evenement.lat2 !== null && evenement.lat2 !== '' &&
        evenement.longi2 !== null && evenement.longi2 !== '')
      ).length;
    }, 0);


    if(nbPoints>0)
    {
      setIsEnoughPoints(true);
    }
    else
    {
      setIsEnoughPoints(false);
    }


  }, [eventCategoriesPage]);

  return (
    
    <DndProvider backend={HTML5Backend}>
    <>
    { isEnoughPoints && (
    <div>
      <div className="relative cardsMap lg:flex lg:items-start lg:gap-6 lg:overflow-hidden md:grid-cols-1 md:grid-gap-1">
  

        {/* MAPPPPP */}
      <div className="relative block w-full lg:min-w-0 lg:flex-1">
            {showFullMapFixed && (
            <ButtonClose
              onClick={() => setShowFullMapFixed(false)}
              className="bg-white absolute z-50 left-3 top-3 shadow-lg rounded-xl w-10 h-10"
            />
          )}

         <div
  className="
    listingSection__wrap
    [ nc-box-has-hover ]
    [ nc-dark-box-bg-has-hover ]

    sticky
    top-[88px]

    w-full
    h-[340px]
    sm:h-[380px]
    md:h-[520px]
    lg:h-[calc(100vh-88px)]

    rounded-md
    overflow-hidden
    w-map

    !p-2
    sm:!p-3
    md:!p-3
    !my-0
    !mb-0
  "
>
     <MapboxGL
              voyageKey={voyageKey}
              selectedCardID={selectedCardID}
              compteurClick={compteurClick}
              onMarkerClick={handleMarkerClick}
              eventCategories={eventCategoriesPage}
              isModif={false}
              onDeplacementMarker={handleDeplacementMarker}
              placementCardID={placementCardID}
              onEffacePlacement={handleEffacePlacement}
            />
          </div>
        </div>

        <div className={`w-full lg:w-[320px] xl:w-[400px] 2xl:w-[580px] flex-shrink-0 lg:px-8 xl:px-8 md:w-full-map md:block lg:hidden overflow-x-auto md:flex md:flex-wrap pt-4 lg:pt-0`}>
  <div ref={listContainerRefSmall} className="flex gap-2 md:flex md:flex-nowrap overflow-x-auto">
{eventCategoriesPage &&
  eventCategoriesPage.map((day, index) => {
    const visibleEvents = day.evenements
      .map((event, eventIndex) => ({
        event,
        eventIndex,
      }))
      .filter(({ event }) => isEventVisible(event));

    return visibleEvents.map(({ event, eventIndex }, visibleIndex) => {
      const isFirstVisibleOfDay = visibleIndex === 0;

      const dayHeader = isFirstVisibleOfDay ? (
        <div className="h-[44px] mb-1 pl-2 text-left">
          <div className="flex items-start gap-2">
            <div
              className="
                w-8
                h-8

                rounded-2xl

                bg-rose-50

                flex
                items-center
                justify-center

                text-rose-600

                shadow-sm
              "
            >
              <i className="las la-calendar text-lg" />
            </div>

            <div className="flex flex-col">
              <h2
                className="
                  text-xs
                  font-bold
                  text-neutral-900
                  dark:text-white

                  leading-tight
                "
              >
                {t("jour")} {day.num_jour}
              </h2>

              <span
                className="
                  mt-0
                  text-[10px]
                  font-medium
                  text-neutral-500
                  dark:text-neutral-400
                "
              >
                {day.date_journee}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div className="h-[44px] mb-1" />
      );

      return (
        <TimelineMobileIntegre
          key={`${day.num_jour}-${eventIndex}-small`}
          day={day}
          dayIndex={index}
          event={event}
          eventIndex={eventIndex}
          dayHeader={dayHeader}
        >
    <div className="">
                {event.typeEv === "L" &&
                      ((event.libelle1 !== null && event.libelle1 !== "") ||
                        (event.libelle2 !== null && event.libelle2 !== "") ||
                        (event.prix !== null && Number(event.prix.replace("", "0"))) > 0) ? ( 
                      <CardLieuIntegre
                        index={`lieu-${event.id}-small`}
                        key={`lieu-${event.id}-small`}
                        symbole_monnaie={symbole_monnaie || '€'}
                        author={{
                          id: 1,
                          firstName: "Alric",
                          lastName: "Truelock",
                          displayName: event.libelle1 || "",
                          email: "atruelock0@skype.com",
                          avatar: event.image || "",
                          bgImage: "https://images.pexels.com/photos/4064835/pexels-photo-4064835.jpeg?auto=compress&cs=tinysrgb&w=500",
                          count: 40,
                          href: "/author",
                          desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
                          jobName: "Author Job",
                          libelle2: event.libelle2 || "",
                          prix: event.prix || "",
                          type: event.type || "",
                          paiement: event.paiement || "",
                          lien: event.lien || "",
                          lien_modifie: event.lien_modifie || "",
                          etat_lien: event.etat_lien || "",
                          document: event.document || "",
                          bloc: event.bloc || "",
                          lat: event.lat || "",
                          longi: event.longi || "",
                          place_id: event.place || "",
                        }}
                        selected={selectedMarkerID === `lieu-${event.id}`}
                        isMap={true}
                        onLocalisationClick={() => handleCardClick(event, getCardID(event))}
                        numDroit={numDroit}
                      />
                    ) : event.typeEv === "T" &&
                      ((event.libelle1 !== null && event.libelle1 !== "") ||
                        (event.libelle2 !== null && event.libelle2 !== "") ||
                        (event.prix !== null && Number(event.prix.replace("", "0")) > 0) ||
                        (event.type !== null && event.type !== "") ||
                        (event.debut !== null && event.debut !== "") ||
                        (event.fin !== null && event.fin !== "")) ? (
                                      
                                      (() => {

                            let prevEvent = null;
                            let nextEvent = null;
                            let simplifie = false;

                            let simplifiePotentiel= (event.location === null || event.location === "" || event.location === "N")
                                 && (event.prix === null || event.prix === "" || event.prix === "0" || event.prix === "0.00")
                                ;

                   if(simplifiePotentiel)
                            {

                               nextEvent =
                                eventIndex < day.evenements.length - 1
                                  ? day.evenements[eventIndex + 1]
                                  : undefined;

                              prevEvent =
                                eventIndex > 0
                                  ? day.evenements[eventIndex - 1]
                                  : undefined;

                            if (!prevEvent && index > 0) {
  const previousDay = eventCategoriesPage[index - 1];

  if (previousDay && previousDay.evenements && previousDay.evenements.length > 0) {
    prevEvent = previousDay.evenements[previousDay.evenements.length - 1];

    if (
      prevEvent &&
      prevEvent.typeEv === "N" &&
      prevEvent.invisible1 === "O" &&
      previousDay.evenements.length > 1
    ) {
      prevEvent = previousDay.evenements[previousDay.evenements.length - 2];
    }
  }
}

                                let libelle1=event.libelle1;

                                if(event.invisible1==="O")
                                {
                                  libelle1=event.libelle2;
                                }

                                let libelle2=event.libelle2;

                                if(prevEvent === undefined || !prevEvent)
                                {
                                   if(event.libelle1 === "")
                                   {
                                  simplifie=true;
                                   }
                                }
                                else if(event.invisible1 === "O" || libelle1 === null || libelle1 === "" )
                                {
                                  simplifie=true;
                                }
                                else if(prevEvent.typeEv === 'L')
                                {
                                  if(prevEvent.libelle1 === libelle1)
                                  {
                                    simplifie=true;
                                  }
                                }
                                else if(prevEvent.typeEv === 'T')
                                {
                                  if(!prevEvent.location || prevEvent.location === "" || prevEvent.location === "N" )
                                  {
  
                                    if(prevEvent.invisible2==="O")
                                    {

                                      if(prevEvent.libelle1 === libelle1)
                                      {
                                        simplifie=true;
                                      }
                                    }
                                    else if(prevEvent.libelle2 === libelle1)
                                    {
                                      simplifie=true;
                                    }
        
                                  }
                                  else //location
                                  {
                                    if(prevEvent.moment === "P")
                                    {
                                      if(prevEvent.libelle1 === libelle1)
                                      {
                                        simplifie=true;
                                      }
                                      
                                    }
                                    else 
                                    {
                                      if(prevEvent.libelle2 === libelle1)
                                      {
                                        simplifie=true;
                                      }
                                    }
                                  }
                                }
                                else if(prevEvent.typeEv === 'N')
                                {
                                  if(prevEvent.libelle2 === libelle1
                                    || prevEvent.libelle1 === libelle1
                                  )
                                  {
                                    simplifie=true;
                                  }
                                }

                                if(simplifie)
                                {
                                    if(nextEvent === undefined || !nextEvent)
                                    {

                                      if(event.libelle2 === null || event.libelle2 === "")
                                      {
                                        simplifie=true;
                                      }
                                       else{
                                         simplifie=false;
                                      }
                                    }
                                    else if(event.invisible2 === "O" || event.libelle2 === null || event.libelle2 === "")
                                    {
                                    
                                      simplifie=true;
                                    }
                                    else if(nextEvent.typeEv === 'L')
                                    {
                                       if(nextEvent.libelle1 === libelle2)
                                      {
                                        simplifie=true;
                                      }
                                      else{
                                         simplifie=false;
                                      }
                                    }
                                    else if(nextEvent.typeEv === 'T')
                                    {
                                      if(!nextEvent.location || nextEvent.location === "" || nextEvent.location === "N" )
                                      {
                                        if(nextEvent.libelle1 === libelle2)
                                        {
                                          simplifie=true;
                                        }
                                        else{
                                         simplifie=false;
                                        }
                                      }
                                      else //location
                                      {
                                        if(nextEvent.moment === "P")
                                        {
                                          if(nextEvent.libelle1 === libelle2)
                                          {
                                            simplifie=true;
                                          }
                                          else{
                                            simplifie=false;
                                          }
                                          
                                        }
                                        else 
                                        {
                                          if(nextEvent.libelle2 === libelle2)
                                          {
                                            simplifie=true;
                                          }
                                           else{
                                            simplifie=false;
                                          }
                                        }
                
                                      }
                                    }
                                    else if(nextEvent.typeEv === 'N')
                                    {
                                      if(nextEvent.libelle2 === libelle2
                                        || nextEvent.libelle1 === libelle2
                                      )
                                      {
                                        simplifie=true;
                                      }
                                       else{
                                         simplifie=false;
                                      }
                                    }
                                }
                                else
                                {
                                  simplifie=false;
                                }

                            }
                            else {
                              simplifie=false;
                            }

                             if(simplifie && prevEvent && nextEvent)
                            {
                              if(prevEvent.typeEv === "T"
                                && (!prevEvent.location
                                   || prevEvent.location !== 'O')
                              )
                              {
                                simplifie=false;
                              }
                            }

                            return ( 
                      <CardTrajetIntegre
                        index={`trajet-${event.id}-small`}
                        key={`trajet-${event.id}-small`}
                        symbole_monnaie={symbole_monnaie || '€'}
                        author={{
                          id: 1,
                          firstName: "Alric",
                          lastName: "Truelock",
                          displayName: event.libelle1 || "",
                          email: "atruelock0@skype.com",
                          avatar: event.image || "",
                          bgImage: "https://images.pexels.com/photos/4064835/pexels-photo-4064835.jpeg?auto=compress&cs=tinysrgb&w=500",
                          count: 40,
                          href: "/author",
                          desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
                          jobName: "Author Job",
                          libelle2: event.libelle2 || "",
                          prix: event.prix || "",
                          type: event.type || "",
                          debut: event.debut || "",
                          fin: event.fin || "",
                          compagnie: event.compagnie || "",
                          ref: event.ref || "",
                          location: event.location || "",
                          distance: event.distance || "",
                          duree: event.duree || "",
                          moment: event.moment || "",
                          paiement: event.paiement || "",
                          lien: event.lien || "",
                          lien_modifie: event.lien_modifie || "",
                          etat_lien: event.etat_lien || "",
                          document: event.document || "",
                          bloc: event.bloc || "",
                          lat: event.lat || "",
                          longi: event.longi || "",
                          lat2: event.lat2 || "",
                          longi2: event.longi2 || "",
                          simplifie: simplifie
                        }}
                        selected={selectedMarkerID === `trajet-${event.id}`}
                        isMap={true}
                        onLocalisationClick={(type) => handleCardClick(event, getCardID(event), type)}
                        numDroit={numDroit}
                      />)
      })()
                      ): event.typeEv === "N" &&
                      event.invisible1 !== "O" &&
                      ((event.libelle1 !== null && event.libelle1 !== "") ||
                        (event.libelle2 !== null && event.libelle2 !== "") ||
                        (event.prix !== null && Number(event.prix.replace("", "0"))) > 0) ? (
                      <CardNuitIntegre
                        index={`nuit-${event.id}-small`}
                        key={`nuit-${event.id}-small`}
                        symbole_monnaie={symbole_monnaie || '€'}
                        author={{
                          id: 1,
                          firstName: "Alric",
                          lastName: "Truelock",
                          displayName: event.libelle1 || "",
                          email: "atruelock0@skype.com",
                          avatar: event.image || "",
                          bgImage: "https://images.pexels.com/photos/4064835/pexels-photo-4064835.jpeg?auto=compress&cs=tinysrgb&w=500",
                          count: 40,
                          href: "/author",
                          desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
                          jobName: "Author Job",
                          libelle2: event.libelle2 || "",
                          prix: event.prix || "",
                          paiement: event.paiement || "",
                          date_paiement_hebergement: event.date_paiement_hebergement || "",
                          acompte_hebergement: event.acompte_hebergement || "",
                          lien: event.lien || "",
                          lien_modifie: event.lien_modifie || "",
                          etat_lien: event.etat_lien || "",
                          document: event.document || "",
                          bloc: event.bloc || "",
                          lat: event.lat || "",
                          longi: event.longi || "",
                          lat2: event.lat2 || "",
                          longi2: event.longi2 || "",
                          place_id: event.place || "",
                        }}
                        selected={selectedMarkerID === `nuit-${event.id}`}
                        isMap={true}
                        onLocalisationClick={(type) => handleCardClick(event, getCardID(event), type)}
                        numDroit={numDroit}
                      />
                    ) : null}
                </div>
  </TimelineMobileIntegre>
);
        });
      })}
  </div>
</div>

      <div className={`min-h-screen w-full lg:w-[420px] xl:w-[460px] 2xl:w-[500px] lg:max-w-[40vw] flex-shrink-0 lg:px-4 xl:px-6 md:w-full-map hidden lg:block`}>
            <div ref={listContainerRef} className="grid min-w-0 grid-cols-1 gap-2 overflow-visible">
           {eventCategoriesPage &&
  eventCategoriesPage.map((day, index) => {
    const hasVisibleEvents = day.evenements.some(isEventVisible);

    const hasPreviousVisibleEvent = eventCategoriesPage
      .slice(0, index)
      .some((previousDay) =>
        previousDay.evenements.some(isEventVisible)
      );

    return (
      <div
        key={`jour-${day.num_jour}`}
        className="relative"
      >
                
               <div
  className="
    relative
    mb-3
    mt-3
    text-center
  "
>
  {/* Prolongement de la timeline entre deux journées */}
  {hasVisibleEvents && hasPreviousVisibleEvent && (
   <div
  className="
    pointer-events-none
    absolute
    left-[14px]
    -top-[13px]
    -bottom-[13px]

    w-px
    -translate-x-1/2

    bg-neutral-400
    dark:bg-neutral-700
  "
/>
  )}
  {day.num_jour > 1 && (
    <div className="mx-auto mb-3 h-px w-[60%] bg-neutral-300" />
  )}

  <div className="h-[44px] flex justify-center">
    <div
      className="
        inline-flex
        items-start
        justify-center
        gap-2
      "
    >
      <div
        className="
          w-8
          h-8

          rounded-2xl

          bg-rose-50

          flex
          items-center
          justify-center

          text-rose-600

          shadow-sm
        "
      >
        <i className="las la-calendar text-lg" />
      </div>

     <div className="flex flex-col items-center">
  <h2
    className="
      text-xs
      font-bold
      text-neutral-900
      dark:text-white
      text-center
      leading-tight
      w-full
    "
  >
    {t("jour")} {day.num_jour}
  </h2>

  <span
    className="
      mt-0.5
      text-[10px]
      font-medium
      text-neutral-500
      dark:text-neutral-400
      text-center
      whitespace-nowrap
    "
  >
    {day.date_journee}
  </span>
</div>
    </div>
  </div>
</div>

                  {day.evenements.map((event, eventIndex) => {
                    if (!isEventVisible(event)) {
                      return null;
                    }

                    return (
                      <TimelineDesktopIntegre
                        key={`${day.num_jour}-${eventIndex}`}
                        dayIndex={index}
                        event={event}
                        eventIndex={eventIndex}
                      >
                    {event.typeEv === "L" && (( event.libelle1 !== null && event.libelle1 !== "") || ( event.libelle2 !== null && event.libelle2 !== "") || (event.prix !== null && Number(event.prix.replace("","0"))) >0 ) ? (
                      <CardLieuIntegre
                      index={`lieu-${event.id}`}
                      key={`lieu-${event.id}`}
                      symbole_monnaie={symbole_monnaie || '€'}
                      author={{
                        id: 1,
                        firstName: "Alric",
                        lastName: "Truelock",
                        displayName: event.libelle1 || "",
                                          email: "atruelock0@skype.com",
                                          avatar: event.image || '',
                                          bgImage: "https://images.pexels.com/photos/4064835/pexels-photo-4064835.jpeg?auto=compress&cs=tinysrgb&w=500",
                                          count: 40,
                                          href: "/author",
                                          desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
                                          jobName: "Author Job",
                                          libelle2: event.libelle2 || '',
                                          prix: event.prix || '',
                                          type: event.type || '',
                                          paiement: event.paiement || '',
                                          lien: event.lien || '',
                                          lien_modifie: event.lien_modifie || '',
                                          etat_lien: event.etat_lien || '',
                                          document: event.document || '',
                                          bloc: event.bloc || '',
                                          lat: event.lat || '',
                                          longi: event.longi || '',
                                          place_id: event.place|| ''
                                          
                                        }}
                           
                                        selected={selectedMarkerID === `lieu-${event.id}`}
                                        isMap={true}
                                        onLocalisationClick={() => handleCardClick(event, getCardID(event))}
                                        numDroit={numDroit}
                    
                      />
                    ) : event.typeEv === 'T' && (( event.libelle1 !== null && event.libelle1 !== "") || ( event.libelle2 !== null && event.libelle2 !== "") 
                        || (event.prix !== null && Number(event.prix.replace("","0")) >0 ) || ( event.type !== null && event.type !== "")
                        || ( event.debut !== null && event.debut !== "")  || ( event.fin !== null && event.fin !== "")) ? (
                    
                    
                                         (() => {

                            let prevEvent = null;
                            let nextEvent = null;
                            let simplifie = false;

                            let simplifiePotentiel= event.type !== "" 
                                 && (event.location === null || event.location === "" || event.location === "N")
                                 && (event.prix === null || event.prix === "" || event.prix === "0" || event.prix === "0.00")
                                ;

                                    if(simplifiePotentiel)
                            {

                               nextEvent =
                                eventIndex < day.evenements.length - 1
                                  ? day.evenements[eventIndex + 1]
                                  : undefined;

                              prevEvent =
                                eventIndex > 0
                                  ? day.evenements[eventIndex - 1]
                                  : undefined;

                             if (!prevEvent && index > 0) {
  const previousDay = eventCategoriesPage[index - 1];

  if (previousDay && previousDay.evenements && previousDay.evenements.length > 0) {
    prevEvent = previousDay.evenements[previousDay.evenements.length - 1];

    if (
      prevEvent &&
      prevEvent.typeEv === "N" &&
      prevEvent.invisible1 === "O" &&
      previousDay.evenements.length > 1
    ) {
      prevEvent = previousDay.evenements[previousDay.evenements.length - 2];
    }
  }
}

                                let libelle1=event.libelle1;

                                if(event.invisible1==="O")
                                {
                                  libelle1=event.libelle2;
                                }

                                let libelle2=event.libelle2;

                                if(prevEvent === undefined || !prevEvent)
                                {
                                   if(event.libelle1 === "")
                                   {
                                  simplifie=true;
                                   }
                                }
                                else if(event.invisible1 === "O" || libelle1 === null || libelle1 === "" )
                                {
                                  simplifie=true;
                                }
                                else if(prevEvent.typeEv === 'L')
                                {
                                  if(prevEvent.libelle1 === libelle1)
                                  {
                                    simplifie=true;
                                  }
                                }
                                else if(prevEvent.typeEv === 'T')
                                {
                                  if(!prevEvent.location || prevEvent.location === "" || prevEvent.location === "N" )
                                  {
  
                                    if(prevEvent.invisible2==="O")
                                    {

                                      if(prevEvent.libelle1 === libelle1)
                                      {
                                        simplifie=true;
                                      }
                                    }
                                    else if(prevEvent.libelle2 === libelle1)
                                    {
                                      simplifie=true;
                                    }
        
                                  }
                                  else //location
                                  {
                                    if(prevEvent.moment === "P")
                                    {
                                      if(prevEvent.libelle1 === libelle1)
                                      {
                                        simplifie=true;
                                      }
                                      
                                    }
                                    else 
                                    {
                                      if(prevEvent.libelle2 === libelle1)
                                      {
                                        simplifie=true;
                                      }
                                    }
                                  }
                                }
                                else if(prevEvent.typeEv === 'N')
                                {
                                  if(prevEvent.libelle2 === libelle1
                                    || prevEvent.libelle1 === libelle1
                                  )
                                  {
                                    simplifie=true;
                                  }
                                }

                                if(simplifie)
                                {
                                    if(nextEvent === undefined || !nextEvent)
                                    {

                                      if(event.libelle2 === null || event.libelle2 === "")
                                      {
                                        simplifie=true;
                                      }
                                       else{
                                         simplifie=false;
                                      }
                                    }
                                    else if(event.invisible2 === "O" || event.libelle2 === null || event.libelle2 === "")
                                    {
                                    
                                      simplifie=true;
                                    }
                                    else if(nextEvent.typeEv === 'L')
                                    {
                                       if(nextEvent.libelle1 === libelle2)
                                      {
                                        simplifie=true;
                                      }
                                      else{
                                         simplifie=false;
                                      }
                                    }
                                    else if(nextEvent.typeEv === 'T')
                                    {
                                      if(!nextEvent.location || nextEvent.location === "" || nextEvent.location === "N" )
                                      {
                                        if(nextEvent.libelle1 === libelle2)
                                        {
                                          simplifie=true;
                                        }
                                        else{
                                         simplifie=false;
                                        }
                                      }
                                      else //location
                                      {
                                        if(nextEvent.moment === "P")
                                        {
                                          if(nextEvent.libelle1 === libelle2)
                                          {
                                            simplifie=true;
                                          }
                                          else{
                                            simplifie=false;
                                          }
                                          
                                        }
                                        else 
                                        {
                                          if(nextEvent.libelle2 === libelle2)
                                          {
                                            simplifie=true;
                                          }
                                           else{
                                            simplifie=false;
                                          }
                                        }
                
                                      }
                                    }
                                    else if(nextEvent.typeEv === 'N')
                                    {
                                      if(nextEvent.libelle2 === libelle2
                                        || nextEvent.libelle1 === libelle2
                                      )
                                      {
                                        simplifie=true;
                                      }
                                       else{
                                         simplifie=false;
                                      }
                                    }
                                }
                                else
                                {
                                  simplifie=false;
                                }

                            }
                            else {
                              simplifie=false;
                            }

                             if(simplifie && prevEvent && nextEvent)
                            {
                              if(prevEvent.typeEv === "T"
                                && (!prevEvent.location
                                   || prevEvent.location !== 'O')
                              )
                              {
                                simplifie=false;
                              }
                            }
                            
                            return ( <CardTrajetIntegre
                    index={`trajet-${event.id}`}
                    key={`trajet-${event.id}`}
                    symbole_monnaie={symbole_monnaie || '€'}
                    author={{
                      id: 1,
                      firstName: "Alric",
                      lastName: "Truelock",
                      displayName: event.libelle1 || '',
                      email: "atruelock0@skype.com",
                      avatar: event.image || '',
                      bgImage: "https://images.pexels.com/photos/4064835/pexels-photo-4064835.jpeg?auto=compress&cs=tinysrgb&w=500",
                      count: 40,
                      href: "/author",
                      desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
                      jobName: "Author Job",
                      libelle2: event.libelle2 || '',
                      prix: event.prix || '',
                      type: event.type || '',
                      debut: event.debut || '',
                      fin: event.fin || '',
                      compagnie: event.compagnie || '',
                      ref: event.ref || '',
                      location: event.location || '',
                      distance: event.distance || '',
                      duree: event.duree || '',
                      moment: event.moment || '',
                      paiement: event.paiement || '',
                      lien: event.lien || '',
                      lien_modifie: event.lien_modifie || '',
                      etat_lien: event.etat_lien || '',
                      document: event.document || '',
                      bloc: event.bloc || '',
                      lat: event.lat || '',
                      longi: event.longi || '',
                      lat2: event.lat2 || '',
                      longi2: event.longi2 || '',
                      simplifie: simplifie
                                            
                    }}
                    //listePecPlanificateur={listePec}                 
                    selected={selectedMarkerID === `trajet-${event.id}`}
                    isMap={true}
                    onLocalisationClick={(type) => handleCardClick(event, getCardID(event), type)}
                    numDroit={numDroit}
                    />)
      })()
                      ) : event.typeEv === 'N' && event.invisible1 !== "O" && (( event.libelle1 !== null && event.libelle1 !== "") || ( event.libelle2 !== null && event.libelle2 !== "") || (event.prix !== null && Number(event.prix.replace("","0"))) >0 ) ? (
                    <CardNuitIntegre
                    index={`nuit-${event.id}`}
                    key={`nuit-${event.id}`}
                    symbole_monnaie={symbole_monnaie || '€'}
                    author={{
                      id: 1,
                      firstName: "Alric",
                      lastName: "Truelock",
                      displayName: event.libelle1 || '',
                      email: "atruelock0@skype.com",
                      avatar: event.image || '',
                      bgImage: "https://images.pexels.com/photos/4064835/pexels-photo-4064835.jpeg?auto=compress&cs=tinysrgb&w=500",
                      count: 40,
                      href: "/author",
                      desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
                      jobName: "Author Job",
                      libelle2: event.libelle2 || '',
                      prix: event.prix || '',
                      paiement: event.paiement || '',
                      date_paiement_hebergement: event.date_paiement_hebergement || '',
                      acompte_hebergement: event.acompte_hebergement || '',
                      lien: event.lien || '',
                      lien_modifie: event.lien_modifie || '',
                      etat_lien: event.etat_lien || '',
                      document: event.document || '',
                      bloc: event.bloc || '',
                      lat: event.lat || '',
                      longi: event.longi || '',
                      lat2: event.lat2 || '',
                      longi2: event.longi2 || '',
                      place_id: event.place|| ''
                                            
                    }}          
                    selected={selectedMarkerID === `nuit-${event.id}`}
                    isMap={true}
                    onLocalisationClick={(type) => handleCardClick(event, getCardID(event), type)}
                    numDroit={numDroit}
                    />
                    ) : null }

                   </TimelineDesktopIntegre>
                    );
                  })}
                </div>
    );
  })}
</div>

            <div className="flex mt-16 justify-center items-center">
            {/* Pagination */}
          </div>
        </div>
      </div>
    </div>
      )}

    { !isEnoughPoints && (
         <div>
         <div className="relative">
        <p>Il n'y a pas de lieu géolocalisé sur le planning pour afficher la carte.</p>
      </div>
      </div>
    )}
    </>
     <Tooltip id="myTooltip" style={{ zIndex: 9999 }}/>
</DndProvider>
  
  );
};


export default SectionCarteIntegre;
